
import React from "react";
import showdown from "showdown";
import { i18nManager } from "../i18n";
import { ITournamentEditionMatch, IWebsitePage } from "../services";
import { NoseurObject } from "@rivtn/noseur";

export type URLSearchParamsValue = string | string[] | number | number[] | undefined | null;

export const Utils = {

    MARKDOWN_CONVERTER: new showdown.Converter(),

    OMNEHOST_SOCIALS: {
        twitch: "omnehost",
        youtube: "omnehost",
        instagram: "omnehost",
        twitter_x: "omnehost",
    },

    loadingState: (style?: React.CSSProperties) => {
        return (<div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10% 5%", ...style }}>
            <img style={{ height: 70, width: 70 }} alt="loading tournament" src="/loading_circle.gif" />
        </div>);
    },

    emptyState: (style?: React.CSSProperties) => {
        return (<div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "20%", ...style }}>
            <i className="fa fa-list" />
            <span style={{ marginTop: 20 }}>{i18nManager.Labels.landing.result_empty}</span>
        </div>);
    },

    signIn: () => {
        window.location = (process.env.REACT_APP_PATULCIUS_AUTH_URL ?? "http://localhost:3005") + "?ref=" + encodeURIComponent(window.location.href) + "&bid=bb48bad1-1385-403a-b7a5-a98a4c6dcbd6" as any;
    },

    updateMeta: (meta: { title: string; desc?: string; logo: string; }) => {
        if (!window.document) return;
        document.title = meta.title + (meta.desc ? " - " + meta.desc : "") + " - OmneHost";
        (window.document.getElementById("__oh-uls-icon__") as any).href = meta.logo;
    },

    getSocialIcon: (social: string) => ({
        twitch: "fa-brands fa-twitch",
        youtube: "fa-brands fa-youtube",
        twitter: "fa-brands fa-x-twitter",
        twitter_x: "fa-brands fa-x-twitter",
        instagram: "fa-brands fa-instagram",
    }[social]),

    getSocialLink: (social: string, username: string) => (({
        twitch: "https://twitch.tv/:username",
        youtube: "https://youtube.com/:username",
        instagram: "https://instagram/:username",
    }[social] ?? "").replace(":username", username)),

    entriesInCustomOrder(obj: NoseurObject<IWebsitePage>, order: string[] = ["HOME", "MERCH", "SCHEDULE", "GALLERY", "ACHIEVEMENTS", "TEAM_HISTORY"]) {
        return Object.entries(obj)
            .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB));
    },

    // Jan 1st, 1 12:13 AM GMT+0:13:35
    fineDate: (date: Date) => {
        const days = date.getDate();

        const getSuffix = (d: any) => {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getFullYear();

        let timeParts = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        }).formatToParts(date);

        const timeStr = timeParts.map(p => {
            if (p.type === 'dayPeriod') return p.value.toUpperCase();
            return p.value;
        }).join('').replace(',', '');

        return `${month} ${days}${getSuffix(days)}, ${year} ${timeStr}`;
    },

    // Feb 18, 2026
    fineDateShort: (date: Date) => {
        const days = date.getDate();
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getFullYear();

        return `${month} ${days}, ${year}`;
    },

    // Feb 28 – Mar 10, 2026
    rangeDate: (fromDate: Date, toDate: Date) => {
        return `${Utils.fineDateShort(fromDate)} - ${Utils.fineDateShort(toDate)}`;
    },

    markdownToHtml(content: string) {
        return Utils.MARKDOWN_CONVERTER.makeHtml(content);
    },

    buildTournamentMatchLink(publicId: string, m: ITournamentEditionMatch) {
        return `${window.location.origin}/to/${publicId}/schedule?edi=${m.tournament_edition.external_id}&match=${m.external_id}`;
    },

}

export * from "./Encryptor";
export * from "./CacheManager";
export * from "./TemplateColors";